const COOKIE_NAME = '__fl_sso';
const COOKIE_DOMAIN = '.joseph-lee.app';

export function setSSOCookie(token) {
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(token)}; domain=${COOKIE_DOMAIN}; max-age=3600; path=/; SameSite=Lax`;
}

export function getSSOCookie() {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function clearSSOCookie() {
  document.cookie = `${COOKIE_NAME}=; domain=${COOKIE_DOMAIN}; max-age=0; path=/`;
}

// Mint the SSO custom token via our own server (admin SDK) — the shared
// getCustomToken cloud function is CORS-blocked from this origin.
export async function fetchSSOToken(user) {
  const idToken = await user.getIdToken();
  const r = await fetch('/api/tp/sso-token', {
    method: 'POST',
    headers: { Authorization: `Bearer ${idToken}` },
  });
  if (!r.ok) throw new Error('sso token fetch failed');
  const j = await r.json();
  return j.token;
}
